import React from 'react';
import {formValueSelector, getFormInitialValues, reduxForm} from 'redux-form'
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import * as PropTypes from 'prop-types';
import {PrimaryButton} from '../../../../common/Button';
import buttonMessages from '../../../../../intl/common/buttonMessages';
import {
    BUTTON_LABEL_ADD_REPLY_COMMENTS,
    BUTTON_LABEL_CLOSE,
    BUTTON_LABEL_FORWARD_TO_DEALER,
    BUTTON_LABEL_FORWARD_TO_NPDC,
    BUTTON_LABEL_REOPEN,
    BUTTON_LABEL_SAVE,
    BUTTON_LABEL_TAKE_BACK,
    FORM_BUTTON_CLOSE,
    FORM_BUTTON_FORWARD_TO_DEALER,
    FORM_BUTTON_FORWARD_TO_NPDC,
    FORM_BUTTON_MARK_AS_READ,
    FORM_BUTTON_REOPEN,
    FORM_BUTTON_SAVE,
    FORM_BUTTON_TAKE_BACK,
    DOCUMENTATION_TICKET_STATUS_IN_PROGRESS_DEALER,
    DOCUMENTATION_TICKET_STATUS_IN_PROGRESS_SUBSIDIARY,
    DOCUMENTATION_TICKET_STATUS_READ_BY_SUBSIDIARY,
    DOCUMENTATION_TICKET_STATUS_REOPENED,
    DOCUMENTATION_TICKET_STATUS_CLOSED,
    FORM_BUTTON_ESCALATE,
    FORM_BUTTON_ANSWER,
    BUTTON_LABEL_ESCALATE,
    BUTTON_LABEL_ANSWER,
    FORM_BUTTON_CREATE_INTERNAL_TICKET,
    BUTTON_LABEL_CREATE_INTERNAL_TICKET, OVAL_PLATE_ORDER_FORM, DOCUMENTATION_TICKET_STATUS_TRANSFERRED,
    FORM_BUTTON_EDIT, FORM_BUTTON_SG_TAKE_BACK, FORM_STATUS_HISTORY_SECTION, BUTTON_LABEL_SAVE_AND_SEND,
} from '../../../../../constants/formConstants';
import {RequiredSpan} from '../../../../common/StyledComponents';
import {withRouter} from 'react-router-dom';
import get from 'get-value';
import ValidFormattedMessage from '../../../../common/ValidFormattedMessage';
import {throttle} from 'throttle-debounce';
import commonMessages from '../../../../../intl/common/commonMessages';
import {moduleRoles} from '../../../../../utils/roles';
import {domains} from '../../../../../constants/Utils';
import {editTechDocListButtonVisibility} from '../../../../../constants/techDocTicketRights';
import {submitBy} from '../../../../../actions/techDoc/actionTechDocTicket';

const SubmitButtons = (props) => {
    const {change, handleSubmit, submitting, initialValues, readOnly, userRights, dirty, roles, dealerNumber, escalationSGs, answeringSGs, canForwardToDealerFromSG, ticketSG, editMode, form, ticket, ticketHistory = [], intlLanguage} = props;

    const sgPermissions = get(roles, `${domains.TECHNICAL_DOCUMENTATION}.sgEditor.sgPermission`, {default: []});

    const getTakeBackSgList = () => {
        return sgPermissions.filter(sg => sg.isActive).map(item => ({key: item.id, value: item.name})).filter(sg => ticketHistory.some(historySg => get(historySg, "toSolutionGroup.id") === sg.key))
    }

    const filteredAnsweringSGs = (answeringSGs || []).filter(sg => ticketHistory.some(historySg => get(historySg, "toSolutionGroup.id") === sg.id));
    const [selectedGroupForEscalate, setSelectedGroupForEscalate] = React.useState(escalationSGs && escalationSGs.length && escalationSGs[0].id);
    const [selectedGroupForAnswer, setSelectedGroupForAnswer] = React.useState(filteredAnsweringSGs && filteredAnsweringSGs.length && filteredAnsweringSGs[0].id);
    const [selectedTakeBackGroup, setSelectedTakeBackGroup] = React.useState(sgPermissions && ticketHistory && sgPermissions.length && ticketHistory.length && getTakeBackSgList().length && getTakeBackSgList()[0].key);

    const ticketStatus = get(initialValues, 'ticketSection.status');
    const statusClosed = ticketStatus === DOCUMENTATION_TICKET_STATUS_CLOSED;
    const ticketGroup = get(ticket, 'group');
    const defaultSG = ticketGroup ? moduleRoles.isSGDefaultEditorForGroup(roles, domains.TECHNICAL_DOCUMENTATION, ticketGroup) : false;

    const hasSomeEscalationSG = Array.isArray(escalationSGs) && escalationSGs.length;

    const canForwardToDealer = typeof canForwardToDealerFromSG === 'boolean' ? canForwardToDealerFromSG : userRights.canForwardToDealer;
    const canClose = typeof canForwardToDealerFromSG === 'boolean' ? (canForwardToDealerFromSG && userRights.canClose) : userRights.canClose;
    const canForwardBackToSubs = userRights.canForwardBackToSubs
    const canReopen = moduleRoles.isSGEditorDocumentation(roles) ? (!!defaultSG && userRights.canReopen) : userRights.canReopen;
    const canEscalateToSG = userRights.canEscalate && hasSomeEscalationSG;
    const canAnswerToSG = userRights.canAnswer && filteredAnsweringSGs && !!filteredAnsweringSGs.length;
    const canForwardToSubs =  userRights.canForwardToSubs && !(moduleRoles.isDealerDocumentation(roles) && ticketSG);
    const canCreateInternalTicket = editMode && moduleRoles.isSGEditorDocumentation(roles) && ticketSG && form !== OVAL_PLATE_ORDER_FORM;
    const isNLevelFlow = Array.isArray(ticketHistory) && ticketHistory.some(h => h.solutionGroup || h.toSolutionGroup)

    const renderBackButton = () => {
        return (
            <PrimaryButton onClick={(e) => {
                e.preventDefault();
                props.history.goBack();
            }} className="btn mr-2 float-right">
                <FormattedMessage {...buttonMessages.BACK}/>
            </PrimaryButton>
        )
    };

    const renderEditButton = () => {
        return (
            <PrimaryButton onClick={
                handleSubmit(values =>
                    props.onSubmit({
                        submitBy: FORM_BUTTON_EDIT,
                    }))
            } className="btn mr-2 float-right">
                <FormattedMessage {...buttonMessages.EDIT}/>
            </PrimaryButton>
        )
    };

    const renderButton = (button, message, changeToStatus, optionalChangeToSolutionGroup) => {
        return (
            <PrimaryButton onClick={throttle(1000, async (e) => {
                e.preventDefault();
                // Unfortunately haven't found any more elegant way to omit validation on MARK_AS_READ button click, this value is checked in REQUIRED validation
                if (button === FORM_BUTTON_MARK_AS_READ) {
                    change('omitValidation', true);
                    await (interval => new Promise(resolve => setTimeout(resolve, interval)))(75);
                }

                await props.submitBy({submittedBy: button})

                handleSubmit(values =>
                    props.onSubmit({
                        newValues: {
                            ...values,
                            ticketSection: {
                                ...values.ticketSection,
                                status: changeToStatus,
                                ...(button === FORM_BUTTON_ANSWER) && {
                                    solutionGroup: {
                                        id: selectedGroupForAnswer,
                                        name: answeringSGs.find(item => selectedGroupForAnswer === item.id).name
                                    }
                                },
                                ...(button === FORM_BUTTON_ESCALATE) && {
                                    solutionGroup: {
                                        id: selectedGroupForEscalate,
                                        name: escalationSGs.find(item => selectedGroupForEscalate === item.id).name
                                    }
                                },
                                ...(button === FORM_BUTTON_SG_TAKE_BACK) && {
                                    solutionGroup: {
                                        id: optionalChangeToSolutionGroup.id,
                                        name: optionalChangeToSolutionGroup.name
                                    }
                                },
                            }
                        },
                        oldValues: initialValues,
                        submitBy: button,
                    }))()
            })
            } className="btn mr-2 float-right" disabled={submitting || (!dirty && button === FORM_BUTTON_SAVE)}>
                <ValidFormattedMessage message={message} intlMessages={buttonMessages}/>
            </PrimaryButton>
        )
    };

    const renderSelectButton = (button, message, changeToStatus, availableOptions, value, setValue) => {
        const moveLeft = {marginLeft: -10, marginRight: 10};
        const selectedSg = {id: value, name: get(availableOptions.find(sg => sg.key === value), "value")}
        return (
            <>
                <div className="input-group-prepend">
                    {renderButton(button, message, changeToStatus, selectedSg)}
                </div>
                <select className="custom-select" value={value} onChange={e => setValue(e.target.value)} style={moveLeft}>
                    {availableOptions.map((item) => <option key={item.key} value={item.key}>{item.value}</option>)}
                </select>
            </>
        )
    };

    const renderEscalateButton = () => {
        const value = selectedGroupForEscalate;
        const setValue = setSelectedGroupForEscalate;
        const availableOptions = escalationSGs.map(item => ({key: item.id, value: item.name}));
        return renderSelectButton(FORM_BUTTON_ESCALATE, BUTTON_LABEL_ESCALATE, DOCUMENTATION_TICKET_STATUS_TRANSFERRED, availableOptions, value, setValue);
    };

    const renderAnswerButton = () => {
        const value = selectedGroupForAnswer;
        const setValue = setSelectedGroupForAnswer;
        const availableOptions = filteredAnsweringSGs.map(item => ({key: item.id, value: item.name}));
        return renderSelectButton(FORM_BUTTON_ANSWER, BUTTON_LABEL_ANSWER, DOCUMENTATION_TICKET_STATUS_TRANSFERRED, availableOptions, value, setValue);
    };

    const renderTakeBackButton = (button, message, changeToStatus) => {
        const value = selectedTakeBackGroup;
        const setValue = setSelectedTakeBackGroup;
        const availableOptions = getTakeBackSgList()
        return renderSelectButton(button, message, changeToStatus, availableOptions, value, setValue);
    };

    const renderReopenButton = () => {
        return renderButton(FORM_BUTTON_REOPEN, BUTTON_LABEL_REOPEN, DOCUMENTATION_TICKET_STATUS_REOPENED);
    };

    const renderCreateInternalTicketButton = (status) => {
        return renderButton(FORM_BUTTON_CREATE_INTERNAL_TICKET, BUTTON_LABEL_CREATE_INTERNAL_TICKET, status);
    };

    const ticketInNonEditableState = () => {
        const buttonVisibility = editTechDocListButtonVisibility[moduleRoles.isDealerDocumentation(roles) ? 'DEALER' : 'EDITOR'];
        return !buttonVisibility.includes(ticketStatus);
    };

    // L3 groups shouldnt be able to close a ticket
    const isL3GroupProcessing = () => {
        const isTicketGroupL3 = get(ticketSG, "name", {default: ""}).includes("L3")
        const isUserGroupL3 = sgPermissions.some(sg => sg.name.includes("L3"))
        return isTicketGroupL3 && isUserGroupL3
    }

    if (readOnly) {
        const ticketBelongsToDealer = moduleRoles.isDealerDocumentation(roles) && dealerNumber === initialValues.ticketSection.dealerNumber;
        const isEditor = moduleRoles.isEditor(roles) || moduleRoles.isSGEditorDocumentation(roles);
        const editorGroups = moduleRoles.isEditorDocumentation(roles) ? moduleRoles.getEditorGroups(domains.TECHNICAL_DOCUMENTATION, roles).map(e => e.group) : false;
        let canSwitchToEdit = !statusClosed;
        const canSgTakeBack = !statusClosed && ticketSG && get(ticketSG, 'id') !== get(defaultSG, 'id') && !moduleRoles.isSGEditorDocumentationInSG(roles, get(ticketSG, 'id')) && sgPermissions.length > 0;

        if (ticketInNonEditableState()) {
            canSwitchToEdit = false;
        } else if (editorGroups && !sgPermissions && !(editorGroups || []).includes(ticketGroup)){
            canSwitchToEdit = false;
        } else if (moduleRoles.isDealerDocumentation(roles) && (!ticketBelongsToDealer || ticketSG)){
            canSwitchToEdit = false;
        } else if (moduleRoles.isSGEditorDocumentation(roles)) {
            if (ticketSG && !moduleRoles.isSGEditorDocumentationInSG(roles, get(ticketSG, 'id', {default:''}))) {
                // ticket is assigned on group which user is not member of
                canSwitchToEdit = false;
            } else if (!ticketSG && !defaultSG) {
                // ticket can be switched to edit
                canSwitchToEdit = false;
            }
        }

        return (
            <div className="d-flex justify-content-end mt-3">
                <form>
                    <div className={canSgTakeBack ? "input-group" : "form-group"}>
                        {renderBackButton()}
                        {canSwitchToEdit && renderEditButton()}
                        {canSgTakeBack && (isNLevelFlow ?
                            renderTakeBackButton(FORM_BUTTON_SG_TAKE_BACK, BUTTON_LABEL_TAKE_BACK, DOCUMENTATION_TICKET_STATUS_TRANSFERRED) :
                            renderButton(FORM_BUTTON_TAKE_BACK, BUTTON_LABEL_TAKE_BACK, DOCUMENTATION_TICKET_STATUS_TRANSFERRED))}
                        {(ticketBelongsToDealer || isEditor) && canReopen && statusClosed && renderReopenButton()}
                    </div>
                </form>
            </div>
        )
    }
    return (
        <div className="d-flex justify-content-between mt-3">
            <div><RequiredSpan>{'*\u00A0'}</RequiredSpan><FormattedMessage {...commonMessages.IS_MANDATORY}/></div>
            <form>
                <div className="input-group">
                    {get(initialValues, 'ticketSection.uuid') && renderBackButton()}
                    {canEscalateToSG && renderEscalateButton()}
                    {canAnswerToSG && renderAnswerButton()}
                    {canReopen && statusClosed && renderReopenButton()}
                    {canForwardBackToSubs && (isNLevelFlow ?
                        renderTakeBackButton(FORM_BUTTON_SG_TAKE_BACK, BUTTON_LABEL_TAKE_BACK, DOCUMENTATION_TICKET_STATUS_IN_PROGRESS_SUBSIDIARY) :
                        renderButton(FORM_BUTTON_TAKE_BACK, BUTTON_LABEL_TAKE_BACK, DOCUMENTATION_TICKET_STATUS_IN_PROGRESS_SUBSIDIARY))}
                    {canClose && !isL3GroupProcessing() && renderButton(FORM_BUTTON_CLOSE, BUTTON_LABEL_CLOSE, DOCUMENTATION_TICKET_STATUS_CLOSED)}
                    {userRights.canSave && renderButton(FORM_BUTTON_SAVE, !editMode && intlLanguage === 'it' ? BUTTON_LABEL_SAVE_AND_SEND : BUTTON_LABEL_SAVE, ticketStatus)}
                    {canForwardToSubs && renderButton(FORM_BUTTON_FORWARD_TO_NPDC, BUTTON_LABEL_FORWARD_TO_NPDC, DOCUMENTATION_TICKET_STATUS_IN_PROGRESS_SUBSIDIARY)}
                    {canForwardToDealer && renderButton(FORM_BUTTON_FORWARD_TO_DEALER, BUTTON_LABEL_FORWARD_TO_DEALER, DOCUMENTATION_TICKET_STATUS_IN_PROGRESS_DEALER)}
                    {userRights.canChangeToReadBySubs && renderButton(FORM_BUTTON_MARK_AS_READ, BUTTON_LABEL_ADD_REPLY_COMMENTS, DOCUMENTATION_TICKET_STATUS_READ_BY_SUBSIDIARY)}
                    {canCreateInternalTicket && renderCreateInternalTicketButton(ticketStatus)}
                </div>
            </form>
        </div>
    )
}

SubmitButtons.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    readOnly: PropTypes.any,
    submitting: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    userRights: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    ticketSG: PropTypes.any,
    ticket: PropTypes.any,
};

function getSolutionGroups(state, schemaType) {
    if (!state.solutionGroupInfo || !state.solutionGroupInfo[schemaType]) {
        return undefined;
    }
    const docType = get(state, 'ticket.docType');
    return state.solutionGroupInfo[schemaType][docType]
}

const mapStateToProps = (state, initialProps) => ({
    ticketHistory: formValueSelector(initialProps.form)(state, `${FORM_STATUS_HISTORY_SECTION}`),
    initialValues: getFormInitialValues(initialProps.form)(state),
    roles: state.profile.userDetail.roles,
    escalationSGs: getSolutionGroups(state.techDocTicket, 'escalationSchemas'),
    answeringSGs: getSolutionGroups(state.techDocTicket, 'answeringSchemas'),
    canForwardToDealerFromSG: get(state, 'techDocTicket.solutionGroupInfo.canForwardToDealer'),
    ticketSG: get(state, 'techDocTicket.ticket.solutionGroup'),
    ticket: get(state, 'techDocTicket.ticket'),
    dealerNumber: state.profile.userDetail.dealerNumber,
    intlLanguage: get(state, 'intl.language')
});

export default reduxForm({})(withRouter(connect(mapStateToProps, {
    submitBy,
})(SubmitButtons)));
